import Vue from  'vue';

export default {

	data() {
		return {
			// randomRoot: ''
		}
	},

	props: {

		// Optional value object used to transit data from parent to child:
        // <parent> -> <core-drag-area> -> <child>
        data: Object
    },




	/*created() {
		this.randomRoot = this.randomString(4);
	},*/

	methods: {

		/*randomString(length){
		    let text = "";
		    const letters = "abcdefghijklmnopqrstuvwxyz0123456789";

		    for( let i=0; i < length; i++ ){
		        text += letters.charAt(Math.floor(Math.random() * letters.length));
		    }

		    return text;
		}*/
	}

}